module.exports = __webpack_public_path__ + "static/media/JHU_logo.156eae95.svg";